import React from 'react';
export function Bonuses() {
  const bonuses = [{
    image: 'https://cdn.shopify.com/s/files/1/0752/3211/6894/files/FOTO_BONO_1.png?v=1776370432',
    label: 'Bono 1',
    title: 'Calculadora Mayorista Pro',
    description: 'Dónde comprar en Argentina para pagar el mínimo por gramo de proteína.',
    value: '$5.500'
  }, {
    image: 'https://cdn.shopify.com/s/files/1/0752/3211/6894/files/FOTO_BONO_2.png?v=1776370483',
    label: 'Bono 2',
    title: 'Guía Sustitutos Sin Gastar',
    description: 'Reemplazá el Whey caro por alternativas locales sin perder ni un gramo de proteína.',
    value: '$4.000'
  }, {
    image: 'https://cdn.shopify.com/s/files/1/0752/3211/6894/files/FOTO_BONO_3.png?v=1776370499',
    label: 'Bono 3',
    title: '15 Recetas Sin Horno',
    description: 'Tu fábrica lista en 10 minutos. Ideal para el verano o cuando no tenés tiempo.',
    value: '$6.500'
  }, {
    image: 'https://cdn.shopify.com/s/files/1/0752/3211/6894/files/FOTO_BONO_4.png?v=1776370516',
    label: 'Bono 4',
    title: 'Barritas Veganas Express',
    description: 'Proteína de plantas sin el impuesto vegano. Resultados idénticos, costo mínimo.',
    value: '$4.500'
  }, {
    image: 'https://cdn.shopify.com/s/files/1/0752/3211/6894/files/FOTO_BONO_5.png?v=1776370545',
    label: 'Bono 5',
    title: 'Método Freezado 3 Meses',
    description: 'Cocinás una vez por semana y tenés stock fresco durante todo el mes.',
    value: '$3.000'
  }, {
    image: 'https://cdn.shopify.com/s/files/1/0752/3211/6894/files/FOTO_BONO_6.png?v=1776370562',
    label: 'Bono 6',
    title: 'Kit Etiquetas Pro',
    description: 'Dales look de marca a tus barritas. Listas para vender en tu entorno o por redes.',
    value: '$1.500'
  }];
  return <section className="bg-white py-12 sm:py-20 px-4 border-b border-[#E2E8F0]" data-id="element-15">
      <div className="max-w-[780px] mx-auto" data-id="element-16">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-17" />

        <span className="inline-block bg-[#2563EB] text-white font-montserrat text-[10px] font-extrabold tracking-[2px] uppercase py-[5px] px-4 rounded-[20px] mx-auto mb-4 block w-fit" data-id="element-18">
          Bonos incluidos — Gratis hoy
        </span>

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-[#0F172A] tracking-tight leading-[1.2]" data-id="element-19">
          Todo lo que recibís además del ebook
        </h2>

        <p className="text-center text-[#475569] text-[15px] mb-10" data-id="element-20">
          6 productos individuales, todos tuyos sin costo extra
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-[18px] max-w-[740px] mx-auto" data-id="element-21">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white border-[1.5px] border-[#E2E8F0] rounded-[14px] overflow-hidden transition-all duration-[0.25s] hover:-translate-y-[5px] hover:shadow-[0_16px_40px_rgba(15,23,42,0.1)] hover:border-[#22C55E]" data-id="element-22">
              <img src={bonus.image} alt={bonus.title} className="w-full aspect-square object-cover block transition-transform duration-[0.4s] hover:scale-[1.04]" data-id="element-23" />
              <div className="p-3 sm:p-[18px]" data-id="element-24">
                <p className="font-montserrat text-[9px] font-extrabold tracking-[2px] uppercase text-[#2563EB] mb-[5px]" data-id="element-25">
                  {bonus.label}
                </p>
                <h3 className="font-montserrat text-sm font-bold mb-[7px] text-[#0F172A] leading-[1.35]" data-id="element-26">
                  {bonus.title}
                </h3>
                <p className="text-[13px] text-[#475569] leading-[1.55] mb-3" data-id="element-27">
                  {bonus.description}
                </p>
                <div className="flex items-center gap-[10px]" data-id="element-28">
                  <span className="text-xs text-[#94A3B8] line-through" data-id="element-29">
                    {bonus.value}
                  </span>
                  <span className="font-montserrat text-[13px] font-extrabold text-[#22C55E]" data-id="element-30">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-31">
          <a href="#comprar" className="inline-block bg-[#22C55E] text-white font-montserrat text-[15px] font-extrabold uppercase tracking-[1.5px] py-[18px] px-11 rounded-lg border-none cursor-pointer no-underline transition-all duration-[0.25s] hover:bg-[#15803D] hover:shadow-[0_8px_32px_rgba(34,197,94,0.4)] hover:-translate-y-0.5 active:translate-y-0" style={{
          animation: 'pulse-green 2.5s ease infinite'
        }} data-id="element-32">
            QUIERO TODO ESTO AHORA &gt;&gt;
          </a>
          <p className="text-xs text-[#94A3B8] mt-3 tracking-[0.5px]" data-id="element-33">
            🔒 Pago único · Acceso inmediato · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}